export default __webpack_public_path__ + "static/media/rove.b1332877.png";